import React, { useEffect, useState } from 'react';
import { Box, Container } from '@mui/material';

import HomeLayout from 'layouts/HomeLayout';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import useWindowSize from 'utils/useWindowSize';

// actions
import { getCoverList } from 'context/actions/cover';

// components
import Slider from 'components/Slider';
import InfoBox from 'components/pages/home/InfoBox';

const HomePage = ({}) => {
    const { t } = useTranslation();

    const { sizes } = useWindowSize();
    const [covers, setCovers] = useState([]);

    useEffect(() => {
        getInitData();
    }, []);
    const getInitData = async () => {
        const resCover = await getCoverList();
        // Backend нь pagination-тэй буцаадаг: { list: [...], meta: {...} }.
        // Slider массив хүлээж авдаг тул .list-ийг задална (бусад хуудастай нэгэн адил).
        if (resCover.status === 'success') setCovers(resCover.data?.list || []);
    };

    return (
        <Container maxWidth={false} disableGutters={true}>
            <Box>
                <Box>
                    <Slider linkData={covers} />
                    <InfoBox
                        image={'/pages/home/founderProfile.png'}
                        // title={t('title.our_history')}
                        paragraph={[
                            { title: t('paragraph.our_history_1'), className: '' },
                            { title: t('paragraph.our_history_2'), className: '' },
                            { title: t('paragraph.our_history_3'), className: '' },
                            { title: t('paragraph.our_history_4'), className: '' },
                        ]}
                        asset1={
                            <div
                                className="absolute right-0 z-[-1] bottom-[220px] bg-center bg-no-repeat bg-contain"
                                style={{
                                    width: `${sizes.sm ? 328 / 2 : 328}px`,
                                    height: `${sizes.sm ? 483 / 2 : 483}px`,
                                    backgroundImage: 'url(/pages/home/asset1.png)',
                                }}
                            ></div>
                        }
                        asset2={
                            <div
                                className="absolute left-1/2 z-[-1] -ml-12 bottom-0 bg-center bg-no-repeat bg-contain"
                                style={{
                                    width: `${sizes.sm ? 240 / 2 : 240}px`,
                                    height: `${sizes.sm ? 354 / 2 : 354}px`,
                                    backgroundImage: 'url(/pages/home/asset2.png)',
                                }}
                            ></div>
                        }
                    />
                    <InfoBox
                        isReverse={true}
                        image={'/pages/home/vision.png'}
                        title={t('title.future_view')}
                        paragraph={[
                            { title: t('paragraph.future_view_1'), className: '' },
                            { title: t('paragraph.future_view_2'), className: '' },
                            { title: t('paragraph.future_view_3'), className: '' },
                            { title: t('paragraph.future_view_4'), className: '' },
                            {
                                title: t('paragraph.future_view_sub_1'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.future_view_sub_2'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.future_view_sub_3'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.future_view_sub_4'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.future_view_sub_5'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            { title: t('paragraph.future_view_5'), className: '' },
                        ]}
                        bigasset={
                            <div
                                className="absolute left-0 z-[-1] bottom-0 bg-center bg-no-repeat bg-contain"
                                style={{
                                    width: `${sizes.sm ? 550 / 2 : 550}px`,
                                    height: `${sizes.sm ? 660 / 2 : 550}px`,
                                    backgroundImage: 'url(/pages/home/asset3.png)',
                                }}
                            ></div>
                        }
                    />
                    <InfoBox
                        image={'/pages/home/value.png'}
                        title={t('title.our_value')}
                        paragraph={[
                            { title: t('paragraph.our_value_1'), className: '' },
                            { title: t('paragraph.our_value_2'), className: '' },
                            { title: t('paragraph.our_value_3'), className: '' },
                            {
                                title: t('paragraph.our_value_sub_1'),
                                // className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.our_value_sub_2'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.our_value_sub_3'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.our_value_sub_4'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.our_value_sub_5'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.our_value_sub_6'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.our_value_sub_7'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.our_value_sub_8'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.our_value_sub_9'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.our_value_sub_10'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                        ]}
                        asset1={
                            <div
                                className="absolute left-1/2 ml-40 z-[-1] bottom-0 bg-center bg-no-repeat bg-contain"
                                style={{
                                    width: `${sizes.sm ? 286 / 2 : 286}px`,
                                    height: `${sizes.sm ? 737 / 2 : 737}px`,
                                    backgroundImage: 'url(/pages/home/asset4.png)',
                                }}
                            ></div>
                        }
                    />

                    <InfoBox
                        bottom={true}
                        isReverse={true}
                        image={'/pages/home/hands.png'}
                        title={t('title.our_goal')}
                        paragraph={[
                            { title: t('paragraph.our_goal_1'), className: '' },
                            { title: t('paragraph.our_goal_2'), className: '' },
                            { title: t('paragraph.our_goal_3'), className: '' },
                            { title: t('paragraph.our_goal_4'), className: '' },
                            {
                                title: t('paragraph.our_goal_sub_1'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.our_goal_sub_2'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            {
                                title: t('paragraph.our_goal_sub_3'),
                                className: '!mt-1',
                                hasChar: true,
                            },
                            { title: t('paragraph.our_goal_5'), className: '' },
                            {
                                title: t('paragraph.our_goal_sub_4'),
                                className: '!mt-1 !ml-1',
                            },
                            {
                                title: t('paragraph.our_goal_sub_5'),
                                className: '!mt-1 !ml-1',
                            },
                            {
                                title: t('paragraph.our_goal_sub_6'),
                                className: '!mt-1 !ml-1',
                            },
                            {
                                title: t('paragraph.our_goal_sub_7'),
                                className: '!mt-1 !ml-1',
                            },
                            { title: t('paragraph.our_goal_6'), className: '' },
                        ]}
                        asset1={
                            <div
                                className="absolute left-0 ml-40 z-[-1] bottom-20 bg-center bg-no-repeat bg-contain"
                                style={{
                                    width: `${sizes.sm ? 258 / 2 : 258}px`,
                                    height: `${sizes.sm ? 710 / 2 : 710}px`,
                                    backgroundImage: 'url(/pages/home/asset5.png)',
                                }}
                            ></div>
                        }
                    />
                </Box>
            </Box>
        </Container>
    );
};

HomePage.Layout = HomeLayout;

export default HomePage;
